// extracted by mini-css-extract-plugin
module.exports = {"root":"factories-main_root__sLTFy","image":"factories-main_image__srNXU","title":"factories-main_title__1FoeZ","text":"factories-main_text__3VM6c"};